module.exports = __webpack_public_path__ + "static/img/14000077.ceb8fe7f.png";